<template>
    <div class="old-comment-holder">
        <button class="badge badge-info comment-toggle" :style="badgeStyle" @click.prevent="visible = !visible">
            <i class="glyphicon glyphicon-comment"></i>
        </button>
        <div class="old-comments" v-if="visible">
            <dl>
                <dt v-if="model.last_year[field_name]">Last year comments</dt>
                <dd>{{ model.last_year[field_name]}}</dd>
            </dl>
            <dl>
                <dt>Current comments</dt>
                <dd>
                  <textarea type="text" v-model="model.current[field_name]" class='form-control' :disabled="isReadOnly">
                  </textarea>
                </dd>
            </dl>
        </div>
    </div>
</template>

<style type="text/css" media="screen">
.old-comment-holder {
    display: inline;
    padding-left: 10px;
}
.old-comment-holder .comment-toggle {
    position: absolute;
    float: right;
    top: 0;
    right: -26px;
}
.old-comments dt, dd { font-size: 14px; }
</style>

<script>
export default {
    props: ['field_name', 'model', 'isReadOnly'],
    data() {
        return {
            visible: false,
            current_message: '',
        }
    },
    created() {
        if (!(this.field_name in Object.keys(this.model.current))) {
            this.$set(this.model, this.field_name, '')
        }
    },
    computed: {
      badgeStyle () {
        if (this.model.last_year[this.field_name] || this.model.current[this.field_name]) {
          return {background: '#009900'}
        }
        return {background: '#337ab7'}
      }
    },
}
</script>
